<template>
<v-container fill-height fluid>
  <StudentSelector ref="StudentSelector"
    @student-selected="studentSelectedHandler">
  </StudentSelector>
	<v-card class="mx-auto" max-width="800px" min-width="400px">
    <v-toolbar
      color="primary"
      dark
      flat>
      <v-toolbar-title>Send SMS</v-toolbar-title>
    </v-toolbar>
    <v-container>
      <v-row>
        <v-col
          cols="12"
          md="12">
          <v-combobox
            v-model="chips"
            :items="items"
            :disabled="maintenanceMode || loading"
            @change="contactChanged"
            chips
            label="Enter mobile number"
            hint="Enter mobile number then press enter."
            persistent-hint 
            multiple
            solo
          >
            <template v-slot:selection="{ attrs, item, select, selected }">
              <v-chip
                v-bind="attrs"
                :input-value="selected"
                close
                @click="select"
                @click:close="remove(item)"
              >
                <strong>{{ item }}</strong>&nbsp;
                <!-- <span>(interest)</span> -->
              </v-chip>
            </template>
          </v-combobox>
        </v-col>
      </v-row>
      
      <v-row>
        <v-col cols="12" md="12">
          <v-btn color="primary" block :disabled="maintenanceMode"
            @click="$refs.StudentSelector.init()">
            <v-icon left>mdi-plus</v-icon>
            Add Students
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          cols="12"
          md="12">
            <v-textarea
              solo
              counter
              auto-grow
              :counter-value="handleContent"
              :disabled="maintenanceMode || loading"
              name="input-7-4"
              label="Enter message content..."
              v-model="message"
            ></v-textarea>

            <h4 v-if="credits != null && !maintenanceMode" class="text-center">
              Credits: {{ credits }}
            </h4>
            <h4 v-if="maintenanceMode" class="text-center">
              SMS Module is currently under maintenance.
            </h4>
        </v-col>
      </v-row>

    </v-container>

    <v-card-actions>
      <v-spacer />
      <v-btn 
        :disabled="maintenanceMode || loading"
        @click="clear">
        Clear
      </v-btn>
      <v-btn 
        color="primary"
        :disabled="maintenanceMode || !credits || loading || !isSendable()"
        v-show="!loading"
        @click="initialSend">
        Send
      </v-btn>
      <v-btn dark
        color="red"
        v-show="loading && countdown == null"
        @click="cancel">
        Cancel ({{this.currentMobileIndex + 1}}/{{chips.length}})
      </v-btn>
      <v-btn 
        color="red"
        v-show="loading && countdown != null"
        @click="cancel">
        Sending In {{ countdown }}
      </v-btn>
    </v-card-actions>
	</v-card>	

</v-container>
</template>

<script>
import Notify from '../../services/notify'
import Api from '../../services/api'
import StudentSelector from '../registrations/StudentSelector'

export default {
  name: 'SmsComp',
  components: { StudentSelector },
  data () {
    return {
      chips: [''],
      items: [''],
      message: 'This is a demo SMS',
      loading: false,
      forceCancel: false,
      countdown: null,
      currentMobileIndex: null,
      refreshInterval: null,
      credits: 1000,
      maintenanceMode: true,
    }
  },
  mounted() {
    // this.refreshInterval = setInterval(() => {
    //   Api.sms.credits()
    //     .then((response) => {
    //       this.credits = parseInt(response.data);
    //     });
    // }, 1000);
  },
  beforeDestroy() {
    console.log('clear interval');
    clearInterval(this.refreshInterval);
  },
  methods: {
    initialSend() {
      Notify.confirm('Send SMS?', "You can cancel this action while the system is sending SMS.")
        .then(() => {
          this.loading = true;
          this.countdown = 3;
          let interval = setInterval(() => {
              if(this.forceCancel) {
                clearInterval(interval);
                this.countdown = null;
                this.loading = false;
                this.forceCancel = false;
                this.currentMobileIndex = null;
                return;
              }
      
              this.countdown--;
              if(this.countdown <= 0) {
                clearInterval(interval);
                this.countdown = null;
                this.send();
              }
            }, 1000);
        }).catch(() => {});
    },

    send(currentIndex) {
      if(this.forceCancel) {
        this.forceCancel = false;
        return;
      }
      currentIndex = (isNaN(currentIndex))? 0 : currentIndex;

      if(!isNaN(currentIndex) && currentIndex < this.chips.length) {
        this.loading = true;
        this.currentMobileIndex =  currentIndex;
        Api.sms.send(this.chips[currentIndex], this.message)
          .then((response) => {
            console.log(response);
            this.loading = false;
            this.send(currentIndex + 1);
          });
      } else {
        this.loading = false;
        this.currentMobileIndex =  0;
        this.forceCancel = false;
        Notify.success.smsSent();
      }

    },
    
    cancel() {
      this.forceCancel = true;
    },

    remove (item) {
      this.chips.splice(this.chips.indexOf(item), 1)
      this.chips = [...this.chips]
    },

    clear() {
      Notify.confirm('Clear all numbers and message content?', "This action can't be undone.")
        .then(() => {
          this.chips = [];
          this.items = [];
          this.message = '';
        }).catch(() => {});
    },

    contactChanged() {
      this.chips = this.checkMobileNumbers(this.chips);
    },

    checkMobileNumbers(mobiles) {
      let filtered = [];
      const pattern = /^(09)\d{9}$/;
      mobiles.forEach(mobile => {
        if(pattern.test(mobile)) {
          filtered.push(mobile);
        }
      });
      return filtered;
    },

    handleContent(value) {
      if(value.length > 0 && value.length > 480) {
        this.message = this.message.substr(0, 480);
      }
      return this.message.length + ' / ' + 480;
    },

    studentSelectedHandler(handleObj) {
      let students = handleObj.students;
      let numbers = [];
      students.forEach((student) => {
        numbers.push(student.mobile);
      });
      this.chips = numbers; 
    },

    isSendable() {
      if(this.chips.length > 0 && this.message.length > 0) {
        return true;
      }
      return false;
    }
  },
}
</script>